import { useVHPlayerConfig } from '@vh/components/vh-types/vhPlayerHooks';
import VHOverlay from '@vh/components/VHOverlay/VHOverlay';
import VHOverlayForCallPopulator from '@vh/components/VHOverlays/VHOverlayForCall/VHOverlayForCallPopulator';

/** @type {React.FC<{wrapperRef: React.MutableRefObject<HTMLDivElement | null>}>} */
const VHOverlaySelector = ({ wrapperRef }) => {
  const vhPlayerConfig = useVHPlayerConfig();

  if (vhPlayerConfig.vhPlayerOverlay === 'call') {
    return <VHOverlayForCallPopulator fullscreenElementRef={wrapperRef} />;
  }

  return <VHOverlay wrapperRef={wrapperRef} />;
};

export default VHOverlaySelector;
